#version 300 es
    
precision highp float;
precision highp sampler3D;

in vec3 pass_textureCoordinates;

out vec4 color;

uniform vec2 windowLevel; //ww, wc
uniform vec3 colorMask;
uniform float alpha;

uniform sampler3D sampler;

// Per-Z classification of a still-filling volume: one texel per slice, holding
// ArrivalState. Only sampled when useArrivalMask is set; a complete volume
// carries no mask and every voxel is real.
uniform sampler2D arrivalMask;
uniform bool useArrivalMask;
// Shown where a slice has not arrived yet, and where retrieval gave up on it.
// A row with no pixels holds zero, which windows to a plausible mid-grey on a
// CT — indistinguishable from soft tissue. These make absent data look absent.
uniform vec3 pendingColor;
uniform vec3 unavailableColor;

vec4 colorModification(float value){
    value = (value - windowLevel.y + (windowLevel.x * 0.5)) / windowLevel.x;
    value *= alpha;
    /*if(value < 0.0){
        discard;
    }*/
    vec3 color = colorMask * value;
    return vec4(color, 1.0);
}

void main() {
    if (useArrivalMask) {
        // The mask spans the same Z extent as the volume, so the volume's own
        // z coordinate indexes it directly. Compared against midpoints rather
        // than for equality: the sampled byte is a normalised float.
        float state = texture(arrivalMask, vec2(pass_textureCoordinates.z, 0.5)).r;
        if (state < 0.75) {
            // Scaled by alpha exactly as a real value is, so the placeholder
            // carries the same weight in a blend as the pixels it stands in for.
            vec3 absent = state < 0.25 ? pendingColor : unavailableColor;
            color = vec4(absent * alpha, 1.0);
            return;
        }
    }
    color = colorModification(texture(sampler, pass_textureCoordinates).r);
}
